/**
 * Theme application — Phase 4-4 / T19.
 *
 * Applies host-supplied CSS custom properties to `document.documentElement`.
 * Only a fixed allow-list of 7 token names is honored — unknown keys are
 * silently dropped to prevent hosts from injecting arbitrary CSS properties
 * (CSS variable injection is benign on its own but the allow-list keeps the
 * theming contract small and predictable).
 *
 * Importers: src/lib/embed/bootstrap.ts (initial `init` apply + `setTheme`
 * handler).
 */
/**
 * Theme allow-list. Hosts may override these CSS custom properties; any other
 * key in the incoming object is dropped. Mirrors the tokens declared as
 * defaults in App.svelte (Brushed Steel + Signal Amber, per DESIGN.md).
 */
const ALLOWED_VARS = new Set([
    '--widget-bg',
    '--widget-bg-elevated',
    '--widget-bg-sunk',
    '--widget-fg',
    '--widget-fg-muted',
    '--widget-fg-dim',
    '--widget-border',
    '--widget-divider',
    '--widget-accent',
    '--widget-accent-deep',
    '--widget-accent-tint',
    '--widget-danger',
    '--widget-danger-tint',
    '--widget-channel-fb',
    '--widget-channel-ig',
    '--widget-channel-wa',
    '--widget-radius',
    '--widget-radius-action',
    '--widget-font',
    '--widget-font-mono',
    '--widget-spacing',
]);
/**
 * Write allow-listed CSS vars to :root. Filters by both key (must be in
 * ALLOWED_VARS) and value type (must be a string). Non-strings, non-allow-
 * listed keys, and `null`/`undefined` values are skipped without throwing.
 */
export function applyTheme(theme) {
    if (!theme || typeof document === 'undefined')
        return;
    const root = document.documentElement;
    for (const [key, value] of Object.entries(theme)) {
        if (!ALLOWED_VARS.has(key))
            continue;
        if (typeof value !== 'string')
            continue;
        root.style.setProperty(key, value);
    }
}
/** Exposed for tests + the embed-sdk to mirror the contract. */
export const ALLOWED_THEME_VARS = ALLOWED_VARS;
//# sourceMappingURL=apply-theme.js.map